<template>
  <div class="summary-card">
    <div class="summary-card-title">
      <file-text-outlined class="summary-card-icon" />
      <span>报告摘要</span>
    </div>
    <div class="summary-card-content">
      <p>
        1. 社区整体进展生态伙伴 <strong>607</strong> 家，贡献者总数 <strong>15,488</strong>人，兼容产品 <strong>1,846</strong> 款；OpenHarmony PMC 总贡献者 <strong>14,240</strong> 人，累计代码量 <strong>143,752,443</strong> 行，涉及 <strong>130</strong> 家组织，SIG 组织 <strong>73</strong> 个（有仓 50 个、无仓 23 个）。统一互联 PMC 贡献者 <strong>1,248</strong> 人、代码量 <strong>8,456,890</strong> 行，组织数量 <strong>42</strong> 家。
      </p>
      <p>
        2. 7 月 XTS 测评共计 <strong>260</strong> 款产品，<strong>21</strong> 款产品驳回，开发者 VOD 累计闭环 <strong>522,409</strong> 条工单，底座共建已有 <strong>11</strong> 家伙伴参与，项目整体处于启动阶段，<strong>7</strong> 家伙伴完成需求认领。
      </p>
    </div>
  </div>
</template>

<script setup>
import { FileTextOutlined } from '@ant-design/icons-vue';
</script>

<style scoped>
.summary-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-left: 4px solid #722ed1;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 32px;
}

.summary-card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a2e;
  margin-bottom: 16px;
}

.summary-card-icon {
  color: #722ed1;
  font-size: 18px;
}

.summary-card-content {
  line-height: 1.8;
  color: #555;
  text-align: left;
  font-size: 15px;
}

.summary-card-content p {
  margin: 0 0 12px 0;
  text-align: left;
}

.summary-card-content p:last-child {
  margin-bottom: 0;
}
</style>
